(function(){
'use strict';

/* ── helpers ── */
const $=s=>document.querySelector(s);
const $$=s=>[...document.querySelectorAll(s)];
const on=(el,ev,fn)=>el&&el.addEventListener(ev,fn);

/* ── header scroll ── */
function initHeader(){
  const h=$('#cb-header');
  if(!h)return;
  on(window,'scroll',()=>h.classList.toggle('scrolled',scrollY>28),{passive:true});
}

/* ── mobile menu ── */
function initMobileMenu(){
  const btn=$('#cb-ham'), nav=$('#cb-mob');
  if(!btn||!nav)return;
  on(btn,'click',()=>{
    const open=btn.classList.toggle('open');
    nav.classList.toggle('open',open);
    btn.setAttribute('aria-expanded',open);
  });
  $$('a',nav).forEach(a=>on(a,'click',()=>{
    btn.classList.remove('open');
    nav.classList.remove('open');
    btn.setAttribute('aria-expanded','false');
  }));
}

/* ── money format ── */
const fmtMoney=cents=>{
  const kr=(cents/100).toLocaleString('sv-SE',{minimumFractionDigits:0,maximumFractionDigits:0});
  return kr+' kr';
};

/* ── cart state ── */
let cartItems=[], cartTotal=0;

async function fetchCart(){
  try{
    const r=await fetch('/cart.js',{headers:{'Content-Type':'application/json'}});
    const c=await r.json();
    cartItems=c.items||[];
    cartTotal=c.total_price||0;
    updateCartUI();
    return c;
  }catch(e){console.warn('cart fetch',e);return null;}
}

async function addToCart(id,qty=1){
  try{
    const r=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:parseInt(id),quantity:parseInt(qty)})
    });
    if(!r.ok){const e=await r.json();throw new Error(e.description||'Error');}
    await fetchCart();
    return true;
  }catch(e){console.warn('add to cart',e);return false;}
}

async function changeItem(key,qty){
  try{
    await fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:parseInt(qty)})
    });
    await fetchCart();
  }catch(e){console.warn('change item',e);}
}

/* ── cart UI ── */
function updateCartUI(){
  const count=cartItems.reduce((s,i)=>s+i.quantity,0);
  const badge=$('#cb-cartbadge');
  const cdCount=$('#cd-count');
  if(badge){badge.textContent=count;badge.classList.toggle('on',count>0);}
  if(cdCount)cdCount.textContent=count;
  renderDrawer();
}

function renderDrawer(){
  const body=$('#cd-body');
  const foot=$('#cd-foot');
  const total=$('#cd-total');
  if(!body)return;
  if(cartItems.length===0){
    body.innerHTML='<div class="cd-empty"><span class="cd-empty-icon">🛒</span><p class="cd-empty-txt">Din kundvagn är tom</p></div>';
    if(foot)foot.style.display='none';
    return;
  }
  if(foot)foot.style.display='block';
  if(total)total.textContent=fmtMoney(cartTotal);
  body.innerHTML=cartItems.map(item=>`
    <div class="cd-item" data-key="${item.key}">
      <div class="cd-item-img">${item.image?`<img src="${item.image}" alt="${item.title||''}" loading="lazy">`:''}
      </div>
      <div class="cd-item-body">
        <div class="cd-item-name">${item.title||''}</div>
        <div class="cd-item-price">${fmtMoney(item.price)}</div>
        <div class="cd-qty">
          <button class="cd-qty-btn" data-key="${item.key}" data-qty="${item.quantity}" data-act="minus" type="button">−</button>
          <span class="cd-qty-val">${item.quantity}</span>
          <button class="cd-qty-btn" data-key="${item.key}" data-qty="${item.quantity}" data-act="plus" type="button">+</button>
        </div>
        <button class="cd-item-rm" data-key="${item.key}" type="button">Ta bort</button>
      </div>
    </div>`).join('');

  $$('.cd-qty-btn',body).forEach(b=>on(b,'click',async()=>{
    const q=parseInt(b.dataset.qty);
    const nq=b.dataset.act==='plus'?q+1:Math.max(0,q-1);
    await changeItem(b.dataset.key,nq);
  }));
  $$('.cd-item-rm',body).forEach(b=>on(b,'click',async()=>await changeItem(b.dataset.key,0)));
}

/* ── cart drawer open/close ── */
function initCartDrawer(){
  const drawer=$('#cd-drawer');
  const overlay=$('#cd-overlay');
  const openBtn=$('#cb-cartbtn');
  const closeBtn=$('#cd-close');

  function open(){
    if(!drawer)return;
    drawer.classList.add('on');
    overlay&&overlay.classList.add('on');
    document.body.style.overflow='hidden';
  }
  function close(){
    if(!drawer)return;
    drawer.classList.remove('on');
    overlay&&overlay.classList.remove('on');
    document.body.style.overflow='';
  }

  on(openBtn,'click',open);
  on(closeBtn,'click',close);
  on(overlay,'click',close);
  on(document,'keydown',e=>{if(e.key==='Escape')close();});

  // custom event
  on(document,'cb:open-cart',open);
  return {open,close};
}

/* ── toast ── */
let toastT;
function toast(msg,err=false){
  const el=$('#cb-toast');
  if(!el)return;
  el.textContent=msg;
  el.style.borderColor=err?'rgba(255,80,80,.28)':'rgba(30,120,255,.28)';
  el.style.opacity='1';
  el.style.transform='translateX(-50%) translateY(0)';
  clearTimeout(toastT);
  toastT=setTimeout(()=>{el.style.opacity='0';el.style.transform='translateX(-50%) translateY(16px)';},3000);
}

/* ── product form ── */
function initProductForm(){
  const form=$('#prod-form');
  const atcBtn=$('#btn-atc');
  const buyBtn=$('#btn-buynow');
  const qtyVal=$('#qty-val');
  const formQty=$('#form-qty');
  const qtyMinus=$('#qty-minus');
  const qtyPlus=$('#qty-plus');

  // qty
  if(qtyMinus&&qtyPlus&&qtyVal){
    on(qtyMinus,'click',()=>{
      const v=Math.max(1,parseInt(qtyVal.value)-1);
      qtyVal.value=v;
      if(formQty)formQty.value=v;
    });
    on(qtyPlus,'click',()=>{
      const v=parseInt(qtyVal.value)+1;
      qtyVal.value=v;
      if(formQty)formQty.value=v;
    });
  }

  // variant buttons
  $$('.variant-btn').forEach(btn=>{
    on(btn,'click',()=>{
      const pos=btn.dataset.option;
      // deselect same option group
      $$('.variant-btn[data-option="'+pos+'"]').forEach(b=>b.classList.remove('selected'));
      btn.classList.add('selected');
      // find matching variant
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant(){
    const variantIdInput=$('#variant-id');
    if(!variantIdInput)return;
    // Try to find matching variant from Shopify product JSON
    const pjEl=$('#product-json');
    if(!pjEl)return;
    try{
      const product=JSON.parse(pjEl.textContent);
      const selected=$$('.variant-btn.selected').map(b=>b.dataset.value);
      const match=product.variants.find(v=>{
        const vals=v.options||[];
        return selected.every((s,i)=>vals[i]===s||vals.some(o=>o===s));
      });
      if(match){
        variantIdInput.value=match.id;
        // update price
        const priceEl=$('#prod-price');
        if(priceEl)priceEl.textContent=fmtMoney(match.price);
        const stickyP=$('#sticky-price');
        if(stickyP)stickyP.textContent=fmtMoney(match.price);
        if(atcBtn){
          atcBtn.disabled=!match.available;
          atcBtn.textContent=match.available?'Lägg i kundvagn':'Slutsåld';
        }
      }
    }catch(e){}
  }

  // add to cart
  if(form&&atcBtn){
    on(form,'submit',async e=>{
      e.preventDefault();
      const vid=$('#variant-id')?.value;
      const qty=parseInt(qtyVal?.value||1);
      if(!vid)return;
      atcBtn.classList.add('btn-loading');
      atcBtn.disabled=true;
      const ok=await addToCart(vid,qty);
      atcBtn.classList.remove('btn-loading');
      atcBtn.disabled=false;
      if(ok){
        atcBtn.classList.add('btn-success');
        const orig=atcBtn.textContent;
        atcBtn.textContent='✓ Tillagd!';
        setTimeout(()=>{atcBtn.classList.remove('btn-success');atcBtn.textContent='Lägg i kundvagn';},2200);
        toast('✓ Produkten lades till i kundvagnen');
        setTimeout(()=>document.dispatchEvent(new CustomEvent('cb:open-cart')),450);
      }else{
        toast('⚠ Kunde inte lägga till produkten',true);
      }
    });
  }

  // buy now
  if(buyBtn){
    on(buyBtn,'click',async()=>{
      const vid=$('#variant-id')?.value;
      const qty=parseInt(qtyVal?.value||1);
      if(!vid){window.location='/checkout';return;}
      buyBtn.classList.add('btn-loading');
      buyBtn.disabled=true;
      const ok=await addToCart(vid,qty);
      if(ok){window.location='/checkout';}
      else{
        buyBtn.classList.remove('btn-loading');
        buyBtn.disabled=false;
        toast('⚠ Kunde inte lägga till produkten',true);
      }
    });
  }
}

/* ── sticky mobile ATC ── */
function initStickyATC(){
  const bar=$('#sticky-atc');
  const btn=$('#sticky-atc-btn');
  const prodSec=$('#product');
  if(!bar)return;
  if(prodSec){
    const obs=new IntersectionObserver(entries=>{
      bar.style.display=entries[0].isIntersecting?'none':'flex';
    },{threshold:.05});
    obs.observe(prodSec);
  }
  if(btn){
    on(btn,'click',async()=>{
      const vid=$('#variant-id')?.value;
      const qty=parseInt($('#qty-val')?.value||1);
      if(!vid)return;
      btn.classList.add('btn-loading');
      btn.disabled=true;
      const ok=await addToCart(vid,qty);
      btn.classList.remove('btn-loading');
      btn.disabled=false;
      if(ok){
        toast('✓ Tillagd i kundvagnen');
        setTimeout(()=>document.dispatchEvent(new CustomEvent('cb:open-cart')),400);
      }
    });
  }
}

/* ── product image thumbnails ── */
function initThumbs(){
  const main=$('#prod-main-img');
  $$('.prod-thumb').forEach(t=>{
    on(t,'click',()=>{
      if(main&&t.dataset.src){
        main.style.transition='opacity .2s,transform .2s';
        main.style.opacity='0';main.style.transform='scale(.97)';
        setTimeout(()=>{main.src=t.dataset.src;main.style.opacity='1';main.style.transform='scale(1)';},200);
      }
      $$('.prod-thumb').forEach(x=>x.classList.remove('on'));
      t.classList.add('on');
    });
  });
}

/* ── FAQ ── */
function initFAQ(){
  $$('.faq-item').forEach(item=>{
    const btn=item.querySelector('.faq-q');
    on(btn,'click',()=>{
      const wasOpen=item.classList.contains('open');
      $$('.faq-item').forEach(i=>{i.classList.remove('open');i.querySelector('.faq-q')?.setAttribute('aria-expanded','false');});
      if(!wasOpen){item.classList.add('open');btn.setAttribute('aria-expanded','true');}
    });
  });
}

/* ── smooth scroll ── */
function initScroll(){
  $$('a[href^="#"]').forEach(a=>{
    on(a,'click',e=>{
      const id=a.getAttribute('href').slice(1);
      const t=id&&document.getElementById(id);
      if(t){e.preventDefault();window.scrollTo({top:t.getBoundingClientRect().top+scrollY-74,behavior:'smooth'});}
    });
  });
}

/* ── scroll reveal ── */
function initReveal(){
  const els=$$('.ben-card,.feat-item,.rev-card,.faq-item,.ba-card,.contact-card');
  els.forEach((el,i)=>{
    el.classList.add('reveal');
    el.style.transitionDelay=(i%4*.1)+'s';
  });
  const obs=new IntersectionObserver(entries=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');obs.unobserve(e.target);}});
  },{threshold:.1,rootMargin:'0px 0px -36px 0px'});
  els.forEach(el=>obs.observe(el));
}

/* ── boot ── */
function boot(){
  initHeader();
  initMobileMenu();
  initCartDrawer();
  initProductForm();
  initStickyATC();
  initThumbs();
  initFAQ();
  initScroll();
  initReveal();
  fetchCart();
}

document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();
})();
